import React, { useId } from 'react';
import {
  BOOK_LANGUAGE_CODES,
  BOOK_LANGUAGE_NAMES_EN,
  isBookLanguageCode,
} from '@living-library/contracts';

const options = BOOK_LANGUAGE_CODES.map((code) => ({
  code,
  name: BOOK_LANGUAGE_NAMES_EN[code] ?? code,
})).sort((a, b) => a.name.localeCompare(b.name, 'en'));

export function LanguagePicker({
  value,
  change,
  className,
}: {
  value: string | null;
  change(value: string): void;
  className: string;
}) {
  const id = useId();
  const code = value?.toLowerCase() ?? '';
  const unsupported = Boolean(code && !isBookLanguageCode(code));
  return (
    <label htmlFor={id}>
      Language
      <select
        id={id}
        className={className}
        value={code}
        required
        onChange={(event) => change(event.target.value)}
      >
        <option value="" disabled>
          Select book language
        </option>
        {unsupported && (
          <option value={code} disabled>
            {value} (current provider value)
          </option>
        )}
        {options.map(({ code, name }) => (
          <option key={code} value={code}>
            {name} ({code})
          </option>
        ))}
      </select>
    </label>
  );
}
